export const Service = {
  async register(payload: {
    username: string;
    email: string;
    password: string;
  }) {
    const response = await fetch('/api/auth2/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return response.json();
  },
};
